import { AUTH_SUCCESS, AUTH_FAIL } from '../types'
import Constants from '../defaults/constants';

export const success = (user) => {
    return (dispatch) => {
        localStorage.setItem(Constants.LOCAL_STORAGE.USER, JSON.stringify(user))
        dispatch({ type: AUTH_SUCCESS, payload: user })
    }
}

export const update = (newUser) => {
    return (dispatch) => {
        let user = localStorage.getItem(Constants.LOCAL_STORAGE.USER);
        user = JSON.parse(user);
        dispatch({ type: AUTH_SUCCESS, payload: { ...user, ...newUser } })
    }
}

export const fetchLocalData = () => {
    return (dispatch) => {
        let user = localStorage.getItem(Constants.LOCAL_STORAGE.USER);
        user = JSON.parse(user);
        if (!!user) dispatch({ type: AUTH_SUCCESS, payload: user })
    }
}

export const logout = () => {
    return (dispatch) => {
        localStorage.removeItem(Constants.LOCAL_STORAGE.USER)
        dispatch({ type: AUTH_FAIL })
    }
}


// WEBPACK FOOTER //
// ./src/actions/auth-actions.js